<template>
  <div>
    <b-modal id="importAssessment-modal" class="modal_body-lg" centered title="Import Assessment" scrollable
      no-close-on-backdrop @close="cancel" size="xl" hide-footer>
      <template #modal-title>
        <div class="">
          <div>Import Assessment</div>
        </div>
      </template>
      <div class="modal_body-lg">
        <b-tabs v-model="activeTab">
          <b-tab title="Owned Assessments" lazy :title-link-class="'m-0'">
            <OwnedAssessmentTable :showAddBtn="true" :refreshList="infiniteAssessment"
              @handleClick="showAssementPreview" @handleAdd="handleAddProblemClick"/>
          </b-tab>
          <b-tab title="Library" lazy :title-link-class="'m-0'">
            <AssessmentTable :showAddBtn="true" :refreshList="infiniteAssessment"
              @handleClick="showAssementPreview" @handleAdd="handleAddProblemClick"/>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <b-modal id="error-modal" ref="error-modal" size="sm" buttonSize="sm" headerClass="p-2 border-bottom-0"
      footerClass="p-2 border-top-0" hide-header-close ok-only centered title="Oops.">
      <p class="my-4">{{ errMsg }}. Please try again</p>
    </b-modal>
  </div>
</template>

<script>
import OwnedAssessmentTable from '../TmInterview/OwnedAssessmentTable.vue';
import AssessmentTable from '../TmInterview/AssessmentTable.vue';
export default {
  name: "importAssessment-modal",
  components: { OwnedAssessmentTable ,AssessmentTable },
  data() {
    return this.initialState();
  },
  computed: {},
  watch: {},

  methods: {
    initialState() {
      return {
        loading: false,
        submitLoading: false,
        selectedItem: false,
        infiniteAssessment: new Date(),
        errMsg: "",
      };
    },

    cancel() {
      Object.assign(this.$data, this.initialState());
      this.$bvModal.hide("importAssessment-modal");
    },
    handleAddProblemClick(item) {
      this.selectedItem = item;
      this.selectedItem.ProblemId = item.AssessmentId;
      this.$bvModal.hide("assessment-preview-modal");
      this.$emit("handleAddAssessment", this.selectedItem);
    },
    showAssementPreview(item) {
      this.selectedItem = item;
      this.selectedItem.ProblemId = item.AssessmentId;
      this.$emit("showAssementPreview", item);
    },
    handleAssessmentPrevClose() {
      this.selectedItem = false;
      this.showAssementPreviewModal = false;
      this.$bvModal.hide("assessment-preview-modal");
    },
  },
};
</script>

<style></style>
